import Attachment from "./Attachment";
import { doRequest } from "./helpers";

export default class CustomTableImportService {
  // Two-step direct-to-S3 upload: client requests a presigned POST via
  // /attachment/upload/s3, posts the file straight to S3, then forwards
  // the resulting s3_key to the import-create endpoint. Mirrors the
  // EmailAttachment / case_data flow so the API never receives multipart
  // file bodies.
  static async upload(
    file,
    onUploadProgress,
    kind = "new-table",
    targetSlug = null
  ) {
    const meta = await Attachment.uploadFile(file, onUploadProgress);
    const data = {
      s3_key: meta.s3_key,
      file_name: meta.file_name,
      file_size: meta.file_size,
      kind,
    };
    if (targetSlug) {
      data.target_slug = targetSlug;
    }
    return doRequest("POST", "/custom_tables/import", { data });
  }

  static async confirm(jobId, payload) {
    return doRequest("PUT", `/custom_tables/import/${jobId}`, {
      data: payload,
    });
  }

  static async getJob(jobId) {
    return doRequest("GET", `/custom_tables/import/${jobId}`);
  }

  static async getArtifactUrl(jobId, kind) {
    return doRequest("GET", `/custom_tables/import/${jobId}/artifact/${kind}`);
  }

  static async abortJob(jobId) {
    return doRequest("DELETE", `/custom_tables/import/${jobId}`);
  }
}
